<div
  *ngIf="(displayInvitee$ | async) && (invitee$ | async) as invitee"
  [attr.data-cy]="'user-list-item-id-' + invitee?.userId">
  <article [attr.data-cy]="requestState$ | async">
    <div
      class="list-item-header"
      (click)="toggleDetails($event)">
      <div class="header-left">
        <div>
          <div class="employee-name">
            <div class="first-name">
              {{
                (loggedInCustomer$ | async)?.prioritizeEmployeeLastName
                  ? invitee?.personalData?.lastName
                  : invitee?.personalData?.firstName
              }}
            </div>
            <div class="last-name">
              {{
                (loggedInCustomer$ | async)?.prioritizeEmployeeLastName
                  ? invitee?.personalData?.firstName
                  : invitee?.personalData?.lastName
              }}
            </div>
          </div>
          <div
            class="employee-customer"
            *ngIf="
              ((isSharedPooler$ | async) || (sourceCustomer$ | async)) &&
              invitee?.customer?.id !== (readyDispo$ | async)?.customerId
            "
            [attr.data-cy]="'origin-customer-id-' + invitee?.customer?.id">
            via
            {{
              invitee?.customer?.displayName +
                (invitee?.personalData?.pricePerHour
                  ? " / CHF " + invitee?.personalData?.pricePerHour
                  : (sourceCustomer$ | async)?.tariff
                  ? " / " + (sourceCustomer$ | async)?.tariff
                  : "")
            }}
          </div>
          <div
            *ngIf="
              (inviteeUser$ | async)?.customerInformation?.[(readyDispo$ | async)?.customerId || ''] &&
              (inviteeUser$ | async)?.customerInformation?.[(readyDispo$ | async)?.customerId || '']?.poolerType "
            class="custom-chip small-pill poolertype-pill mobile-only">
            {{(inviteeUser$ | async)?.customerInformation?.[(readyDispo$ | async)?.customerId || '']?.poolerType?.displayName | uppercase }}
          </div>
        </div>
        <div
          *ngIf="hasOpenHoursToApprove$ | async"
          class="attention-chip"
          data-cy="approve-hours-chip">
          {{ "checkHours" | i18n }}
        </div>
        <div
          *ngIf="
            (job$ | async)?.status === jobStatusEnum.ARCHIVED &&
            (hasHoursToRecord$ | async) &&
            !(hasOpenHoursToApprove$ | async) &&
            invitee?.status === inviteeStatusEnum.BOOKED
          "
          class="attention-chip"
          data-cy="record-hours-chip">
          {{ "recordHours" | i18n }}
        </div>
        <div
          *ngIf="
            (inviteeUser$ | async)?.customerInformation?.[(readyDispo$ | async)?.customerId || ''] &&
            (inviteeUser$ | async)?.customerInformation?.[(readyDispo$ | async)?.customerId || '']?.poolerType "
          class="custom-chip small-pill poolertype-pill no-mobile">
          {{(inviteeUser$ | async)?.customerInformation?.[(readyDispo$ | async)?.customerId || '']?.poolerType?.displayName | uppercase }}
        </div>
      </div>
      <div class="header-right">
        <div>
          <div
            *ngIf="invitee?.additionalInfo || (availabilityNote$ | async)"
            class="availability-note text-m"
            data-cy="availability-note"
            #tooltip="matTooltip"
            (click)="$event.stopPropagation(); tooltip.toggle()"
            [matTooltip]="
              (invitee?.additionalInfo
                ? (availabilityNote$ | async)
                  ? invitee?.additionalInfo +
                    '\n\n' +
                    (availabilityNote$ | async)
                  : invitee?.additionalInfo
                : (availabilityNote$ | async)) || ''
            "
            matTooltipPosition="above">
            <mat-icon
              class="size-20 text-icon-grey"
              svgIcon="note"></mat-icon>
            <span class="d-none d-md-block">
              {{ "hasNote" | i18n }}
            </span>
            <span class="d-block d-md-none">
              {{ "note" | i18n }}
            </span>
          </div>
          <div
            class="rest-warning text-error"
            *ngIf="
              (restStatus$ | async) &&
              !(restStatus$ | async)?.hasRested &&
              invitee?.status !== inviteeStatusEnum.WORKING &&
              invitee?.status !== inviteeStatusEnum.CANCELED &&
              invitee?.status !== inviteeStatusEnum.DECLINED
            "
            data-cy="user-list-item__low-rest-warning"
            #restWarningTooltip="matTooltip"
            (click)="$event.stopPropagation(); restWarningTooltip.toggle()"
            [matTooltip]="(restWarning$ | async) || ''"
            matTooltipPosition="above">
            <mat-icon
              class="size-20 text-icon-error rest-warning-icon text-m"
              svgIcon="bed"></mat-icon>
            <span class="d-none d-md-block">
              {{ "restNotGuaranteed" | i18n }}
            </span>
            <span class="d-block d-md-none">
              {{ "restTime" | i18n }}
            </span>
          </div>
          <app-job-partial-time-chip
            class="partial-times-chip"
            data-cy="partial-times-chip"
            *ngFor="let partialTime of invitee?.partialTimes"
            [partialAcceptTime]="partialTime"></app-job-partial-time-chip>
          <app-previous-jobs-logs
            [user]="(inviteeUser$ | async) ?? undefined"
            [invitee]="invitee"
            [departmentId]="(job$ | async)?.department?.id ?? ''">
          </app-previous-jobs-logs>
          <ng-container
            *ngIf="(inviteeUser$ | async)?.customerInformation?.[(readyDispo$ | async)?.customerId || '']?.monthlyHours">
            <app-monthly-working-hours
              [user]="(inviteeUser$ | async) ?? undefined"
              [customerId]="(readyDispo$ | async)?.customerId || ''"
              [jobDate]="(job$ | async)?.date || ''">
            </app-monthly-working-hours>
          </ng-container>
        </div>
        <button
          type="button"
          [attr.data-cy]="'user-list-item__state'"
          class="transparent-pill-button icon-only"
          (click)="$event.stopPropagation(); openBottomSheet()">
          <app-job-invitee-status-icon
            [invitee]="invitee"></app-job-invitee-status-icon>
        </button>
        <div
          *ngIf="(count$ | async) && (totalCount$ | async)"
          class="availableCount"
          data-cy="count-wrapper">
          <span data-cy="available-count">{{ count$ | async }}</span> /
          <span data-cy="job-count">{{ totalCount$ | async }}</span>
        </div>
        <button
          *ngIf="dropdownMenu$ | async as dropdownMenu"
          type="button"
          class="transparent-pill-button icon-only"
          [disabled]="isDropdownDisabled$ | async"
          [matMenuTriggerFor]="dropdownMenu"
          [matMenuTriggerData]="{
            invitee: invitee,
            resource: inviteeUser$ | async
          }"
          matTooltipPosition="above"
          (click)="$event.stopPropagation()"
          data-cy="more-options-button"
          [matTooltip]="
            ('moreOptions' | i18n) || 'weitere optionen' | titlecase
          ">
          <mat-icon svgIcon="menu-dot"></mat-icon>
        </button>
      </div>
    </div>
    <div
      class="invitee-list-item__time-tracking d-flex flex-column flex-md-row"
      *ngIf="inviteeHasTimeTracking$ | async">
      <app-time-tracking
        [job]="(job$ | async) || undefined"
        [invitee]="invitee"
        [isPooler]="false"></app-time-tracking>
    </div>
    <div
      class="collapse-wrapper"
      [class.collapsed]="!(animationShowDetails$ | async)">
      <div
        *ngIf="showDetails$ | async"
        class="collapse-child"
        [attr.data-cy]="
          'user-list-item-details-' + (inviteeUser$ | async)?._id
        ">
        <user-list-item-details
          class="list-item-details"
          [noPadding]="true"
          [user]="(inviteeUser$ | async) || undefined"
          [invitee]="invitee"></user-list-item-details>
      </div>
    </div>
  </article>
</div>
